/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Service_HelpInputs */

const de_commons_footer_service_help = /** @type {(inputs: Commons_Footer_Service_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfebereich`)
};

/** @type {(inputs: Commons_Footer_Service_HelpInputs) => LocalizedString} */
const en_commons_footer_service_help = de_commons_footer_service_help;

/**

* @param {Commons_Footer_Service_HelpInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_service_help = /** @type {((inputs?: Commons_Footer_Service_HelpInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Service_HelpInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_service_help(inputs)
	return en_commons_footer_service_help(inputs)
});